import { render } from "./ModalUsers.vue?vue&type=template&id=2188598c&scoped=true&ts=true"
import script from "./ModalUsers.vue?vue&type=script&lang=ts"
export * from "./ModalUsers.vue?vue&type=script&lang=ts"

import "./ModalUsers.vue?vue&type=style&index=0&id=2188598c&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2188598c"]])

export default __exports__